var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._t("default",null,{"item":_vm.multiple ? _vm.assignMultipleParcelButton : _vm.assignParcelButton,"defaultAction":_vm.assignParcelAction})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }